// Mock data for Shipmaster Fulfillment landing page

export const navItems = [
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Savings Calculator', href: '#calculator' },
  { label: 'Comparison', href: '#comparison' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Resources', href: '#resources', hasDropdown: true },
  { label: 'Contact', href: '#contact', hasDropdown: true },
];

export const featureCards = [
  {
    icon: 'ShieldCheck',
    title: 'No Hidden Fees',
    description: 'Pay only for what you use. No hidden fees.',
  },
  {
    icon: 'Zap',
    title: 'Flexible & Fair',
    description: 'No contracts. No minimums. Leave when you want.',
  },
  {
    icon: 'Store',
    title: 'Shopify Native',
    description: 'Works with your Shopify store. Simple setup.',
  },
];

export const platformLogos = [
  { name: 'Shopify', text: 'Shopify' },
  { name: 'Amazon Seller Central', text: 'amazon' },
  { name: 'TikTok Shop', text: 'TikTok Shop' },
  { name: 'Etsy', text: 'Etsy' },
  { name: 'WooCommerce', text: 'WOO' },
  { name: 'Squarespace', text: 'SQUARESPACE' },
  { name: 'Wix', text: 'WIX' },
  { name: 'eBay', text: 'ebay' },
];

export const howItWorksSteps = [
  {
    step: 1,
    icon: 'Store',
    title: 'Connect Your Store',
    description: 'Connect your Shopify store in minutes. No technical lift required.',
  },
  {
    step: 2,
    icon: 'Package',
    title: 'We Handle Everything',
    description: 'We receive your inventory, pick, pack, and ship. You focus on running your business.',
  },
  {
    step: 3,
    icon: 'TrendingUp',
    title: 'Scale Worry-Free',
    description: 'Pay for what you use. Scale up or down freely. Cancel anytime.',
  },
];

export const pricingItems = [
  {
    icon: 'Box',
    title: 'D2C Order Fulfillment',
    price: '$2.00',
    unit: 'per order',
    note: 'Additional Picks FREE!',
    highlighted: true,
  },
  {
    icon: 'Warehouse',
    title: 'Storage',
    price: '$25',
    unit: '/pallet',
    note: 'Only pay for the pallet space you actually use',
    highlighted: false,
  },
  {
    icon: 'Truck',
    title: 'Freight Management',
    price: '50-60% Off',
    unit: '',
    note: 'Save 50-60% off standard carrier rates',
    subnote: 'Rate shopping & routing included',
    highlighted: false,
  },
];

export const includedFeatures = [
  'No monthly minimums',
  'No commitments',
  'Transparent fees',
  'Shopify integration',
  'Real-time tracking',
  'Fast 1-2 day shipping',
  'Dedicated account support',
];

export const otherServices = [
  { service: 'Receiving', price: '$15/pallet' },
  { service: 'Kitting & Bundling', price: 'Quote-based' },
  { service: 'Returns Processing', price: '$3/return' },
  { service: 'Custom Packaging', price: 'Pass-through cost' },
  { service: 'Long-term Storage', price: '$50/pallet/mo' },
];

export const competitorData = [
  {
    provider: 'Shipmaster Fulfillment',
    label: 'YOUR SAVINGS',
    pickFee: '$2/order',
    additionalItems: 'FREE',
    storageModel: '$25/pallet (prorated)',
    storageNote: 'Pay only for pallet space used',
    receiving: '$15/pallet',
    freight: 'Included',
    minimum: '$0',
    highlighted: true,
  },
  {
    provider: 'ShipBob',
    pickFee: 'Quote-based',
    additionalItems: '$0.20\u2013$0.25/pick',
    storageModel: 'Space-based (bins, shelves, pallets)',
    receiving: '$25\u2013$40/hr',
    freight: 'Varies',
    minimum: '~$275/mo',
  },
  {
    provider: 'Flexport',
    pickFee: 'Per-unit (varies)',
    additionalItems: 'Varies',
    storageModel: 'Pallet-based (~$25/pallet/mo)',
    receiving: '~$13/pallet',
    freight: 'Varies',
    minimum: '$5,000/mo (Jan 2026)',
  },
  {
    provider: 'Amazon MCF',
    pickFee: '~$6.99+/unit',
    additionalItems: 'Tiered discounts',
    storageModel: 'Cubic-foot based (seasonal)',
    receiving: 'FBA inbound fees',
    freight: '0% (embedded)',
    minimum: 'None stated',
  },
  {
    provider: 'Ryder E-Commerce',
    pickFee: 'Quote-based',
    additionalItems: 'Quote-based',
    storageModel: 'Space-based (quote)',
    receiving: 'Quote-based',
    freight: 'Quote-based',
    minimum: 'Quote-based',
  },
];

export const reviews = [
  {
    initials: 'JD',
    name: 'Jonathan Demel',
    company: 'Founder, Visibly Toxic',
    category: 'Apparel & Streetwear',
    orderRange: '1,000\u201310,000 orders',
    date: 'Apr 2026',
    rating: 5,
    text: "Switching to Shipmaster was the best move I've made for the brand. Orders go out same-day, the packaging looks dialed in, and I actually get human responses when I message them, not a ticket queue. They genuinely care about how my product hits the customer's doorstep.",
  },
  {
    initials: 'JP',
    name: 'John P.',
    company: 'Operations, ASH by Ashley Benson',
    category: 'Beauty & Lifestyle',
    orderRange: '1,000\u201310,000 orders',
    date: 'Apr 2026',
    rating: 5,
    text: "Shipmaster's been a real partner, not just a warehouse. They handled our launch volume without a hiccup, kept inventory tight, and made our unboxing feel premium across every order. Communication is fast and honest. That's rare in this industry.",
  },
  {
    initials: 'JW',
    name: 'Jeff W.',
    company: 'Founder, Scentsome',
    category: 'Beauty & Wellness',
    orderRange: 'Less than 1,000 orders',
    date: 'Mar 2026',
    rating: 5,
    text: "I came to Shipmaster after getting burned by a bigger 3PL that nickel-and-dimed me on every line item. The pricing here is straightforward, the team is responsive, and our customers have noticed the difference. Fewer complaints, faster delivery, better packaging.",
  },
  {
    initials: 'JK',
    name: 'Jared Kmiecik',
    company: 'Amazon Wholesaler',
    category: 'Amazon Wholesale',
    orderRange: '10,000+ orders',
    date: 'Mar 2026',
    rating: 5,
    text: "As a wholesale seller, prep and routing accuracy are everything. One bad shipment and Amazon hits you. Shipmaster's prep team is meticulous. Every box is labeled, palletized, and ASN'd correctly the first time. They've saved me hours of cleanup and a lot of money in chargebacks.",
  },
  {
    initials: 'JW',
    name: 'Joseph Wheeler',
    company: 'Amazon FBA Seller',
    category: 'Amazon FBA',
    orderRange: '1,000\u201310,000 orders',
    date: 'Feb 2026',
    rating: 5,
    text: "I run a multi-SKU FBA operation and Shipmaster has become a quiet engine behind it. Prep is fast, FNSKU labeling is clean, and they catch issues before they become problems, like flagging when a SKU is short before it's an Amazon stockout. That kind of attention is hard to find.",
  },
  {
    initials: 'VK',
    name: 'Vince Kube',
    company: 'Amazon Wholesaler',
    category: 'Amazon Wholesale',
    orderRange: '10,000+ orders',
    date: 'Feb 2026',
    rating: 5,
    text: "Shipmaster has been the most consistent 3PL I've worked with. Receiving turnaround is fast, inventory counts are accurate, and the team treats my product like it's their own. I've referred multiple sellers to them and every single one has stayed.",
  },
];

export const calendarSlots = [
  { day: 'Mon', date: 12, available: true },
  { day: 'Tue', date: 13, available: true },
  { day: 'Wed', date: 14, available: false },
  { day: 'Thu', date: 15, available: true },
  { day: 'Fri', date: 16, available: true },
];

export const timeSlots = ['9:00 AM', '10:30 AM', '12:00 PM', '2:00 PM', '3:30 PM', '5:00 PM'];
